<template>
  <div v-loading="loading">
    <div class="card card-custom card-stretch gutter-b">
      <div class="card-header">
        <div class="card-title">
          <span class="card-icon">
            <i class="flaticon2-delivery-package text-primary"></i>
          </span>
          <h3 class="card-label"><b class="title-header">{{BusinessTitle}}</b></h3>
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-4">
          <div class="ml-4" v-if="url_link">
            <p>＜委託先申請フォーム＞</p>
            <a :href="url_link" target="_blank">{{url_link}}</a>
          </div>
          <div v-if="(currentUser.super_user == 1)">
            <div class="ml-4" v-if="!form_id">
              <el-button type="primary mt-8" @click="createdForm()">委託先申請フォーム作成</el-button>
            </div>
            <div class="ml-4" v-else>
                <el-button type="primary mt-8" @click="updateForm()">委託先申請フォーム更新</el-button>
            </div>
          </div>
        </div>
        <el-row>
          <el-form ref="ruleForm" :model="form" class="form-base mt-4">
            <el-col :span="4">
              <el-form-item prop="search">
                <el-input class="bg-gray-item" v-model="form.search" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary ml-4 " @click="search()">検索</el-button>
            </el-col>
            <input type="hidden" name="_csrf" v-model="form._csrf" />
          </el-form>
          </el-row>
          <div class="row float-right pr-5">
            <my-pagination
                class="pagination"
                v-if="data && data.total"
                :total-record="parseInt(data.total)"
                :current-page="parseInt(data.current_page)"
                :page-size-default="parseInt(data.per_page)"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
            />
          </div>
        <table id="uniquetable" class="table rounded table-top" style="width: 100%;">
          <thead class="thead-dark text-center">
            <tr>
              <th @click="sortLabel('display_name',sort.display_name)" style="width: 20%">委託先</th>
              <th @click="sortLabel('email',sort.email)" style="width: 20%">ユーザーID</th>
              <th @click="sortLabel('contract_amount',sort.contract_amount)" style="width: 20%">契約額</th>
              <th @click="sortLabel('status',sort.status)" style="width: 10%">ステータス</th>
              <th @click="sortLabel('verage_price',sort.verage_price)" style="width: 10%">予算消化率</th>
              <th @click="sortLabel('contract_details',sort.contract_details)" style="width: 20%">契約内容</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="data && data.data.length > 0" v-for="(value) in data.data">
              <td style="width: 20%" class="text-break">
                <router-link :to="{ name: 'subcontractor-detail',params: { id: value.answer_id }}">
                  {{value.display_name}}
                </router-link>
              </td>
              <td style="width: 20%" class="text-break">{{value.email}}</td>
              <td style="width: 20%" class="text-break">{{formatMoney(value.contract_amount)}}</td>
              <td style="width: 10%" class="text-break">{{value.status == 0 ? '申請中' : value.status == 1 ? '承認済' : '否認'}}</td>
              <td style="width: 10%" class="text-break">{{value.verage_price}}</td>
              <td style="width: 20%" class="text-break">{{value.contract_details}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import mixinSearch from "@/mixins/searchMixin";
import apiService from "@/core/services/api.service";
import { mapActions, mapGetters } from 'vuex';
import { LIST_ANSWER,CHECK_FORM_URL_USER } from "@/core/services/store/formAnswer.module";
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import { ENV } from "@/core/config/env";
import { SUCCESS_MESSAGE, constants } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
  mixins: [mixinSearch],
  data() {
    return {
      loading: false,
      form_id:'',
      url_link :'',
      sort: {
        display_name: 'asc',
        contract_amount: 'asc',
        email: 'asc',
        status: 'asc',
        verage_price: 'asc',
        contract_details: 'asc',
      },
      data: [],
      form: {
        search: '',
        _csrf:''
      }
    };
  },

  async created() {
    this.loading = true;
    this.form.search = this.$route.query.display_name
    await this.listAnswer(this.queryParam)
      await this.checkFormUrlUser()
    if (this.BusinessTitle == null) {
      await this.setTitleBusiness()
    }
    let currentData = this.getListAnswer;
    if (currentData.form_answer){
      this.data = this.getListAnswer.form_answer
    }
    if (this.listCheckFormUsers.form1) {
      this.form_id = this.listCheckFormUsers.form1.form_url
      this.url_link = ENV.APP_URL_DOMAIN + this.currentUser.tenant_code + '/' + this.listCheckFormUsers.form1.form_url
    }
    this.form._csrf = getCsrfRandom()
    this.loading = false;
  },
  computed: {
    ...mapGetters(["getListAnswer", "listCheckFormUsers", "BusinessTitle", "currentUser"]),
    queryParam() {
      return this.$route.query
    },
  },
  watch: {
    async queryParam() {
      this.loading = true;
      await this.listAnswer(this.queryParam)
      this.data = this.getListAnswer.form_answer
      this.loading = false;
    }
  },
  methods: {
    ...mapActions([LIST_ANSWER, CHECK_FORM_URL_USER, SET_TITLE_BUSINESS]),
    sortLabel(nameLabel, value) {
      if (value == 'desc') {
        this.sort[nameLabel] = 'asc'
      } else {
        this.sort[nameLabel] = 'desc'
      }
      if (value == 'desc') {
        this.data.data.sort((a, b) => a[nameLabel] > b[nameLabel] ? 1 : -1);
      } else {
        this.data.data.sort((a, b) => b[nameLabel] > a[nameLabel] ? 1 : -1);
      }
    },
    formatMoney(value) {
      return BigInt((`${value}`).replace(/\D/g, ''), 10).toLocaleString('ja-JP', { currency: 'JPY' })
    },
    createdForm() {
      this.loading = true
      apiService.post(`form/create-form`).then(async (data) => {
        if (data && data.data && data.data.success) {
          this.url_link = ENV.APP_URL_DOMAIN + this.currentUser.tenant_code + '/' + data.data.data[0].form_url
          this.form_id = data.data.data[0].form_url
          this.notifySuccess(SUCCESS_MESSAGE)
        } else {
          if (data.data.code == 403) {
            this.notifyError(data.data.message)
          } else {
            this.notifyError(data.data.message)
          }
        }
      })
        .catch(e => {
          this.notifyError(e)
          this.loading = false

        })
      this.loading = false
    },
    updateForm() {
      this.loading = true
      apiService.post(`form/edit-form/${this.form_id}`).then(async (data) => {
        if (data && data.data && data.data.success) {
          this.url_link = ENV.APP_URL_DOMAIN + this.currentUser.tenant_code + '/' + data.data.data[0].form_url
          this.form_id = data.data.data[0].form_url
          this.notifySuccess(SUCCESS_MESSAGE)
        } else {
          if (data.data.code == 404) {
            this.notifyError(data.data.message)
          } else {
            this.notifyError('error server')
          }
        }
      })
        .catch(e => {
          this.notifyError(e)
          this.loading = false

        })
      this.loading = false
    },
    async search() {
      this.loading = true
      this.data = []
      this.$router.push({ name: 'subcontractor', query: { display_name: this.form.search ? this.form.search.trim() : ''} })
      await this.listAnswer({ display_name:  this.form.search ? this.form.search.trim() : ''})
      this.data = this.getListAnswer.form_answer
      this.loading = false
    },
    handleSizeChange(val) {
      this.sizeChange('subcontractor',val);
    },
    handleCurrentChange(val) {
      this.pageChange('subcontractor',val);
    },
  }
}
</script>

<style scoped>
.table-top,.table-top th,.table-top td {
  border: 1px solid #EBEDF3;
  border-collapse: collapse;
}
table thead tr th {
  cursor: pointer;
}
#uniquetable thead {
  display: block;
  width: 100%;
}

#uniquetable tbody {
  display: block;
  width: 100%;
  /* max-height: 450px; */
  /* overflow-y: overlay; */
}

#uniquetable tbody tr,
#uniquetable thead tr {
  width: 100%;
  display: table;
}

.pagination .button-arrow-pagination{
    margin-top: 2px;
    background-color: #f4f4f5;
    color: #606266;
    height: 28px;
    min-width: 30px;
    border-radius: 2px;
}
.pagination .el-pager{
    padding-left: 30px;
    padding-right: 30px;
}

.pagination .prev-arrow{
    position: absolute;
    left: 231px;
}
.pagination .el-pagination span:not([class*=suffix]){
    text-align: right;
    min-width: 100px;
}
.pagination .wapper-pagination{
    position: relative;
}

.pagination .next-arrow{
    position: absolute;
    right: 0;
    bottom: 2px;
}

</style>
